class FileHelper {
  static downloadFile(url, headers) {
    let nameRegex = new RegExp("filename[^;=\\n]*=(?:(\\\\?['\"])(.*?)\\1|(?:[^\\s]+'.*?')?([^;\\n]*))");
    let matches = nameRegex.exec(headers["content-disposition"]);

    let fileName = "download";
    if (matches.length > 0) {
      fileName = matches[0].substring(9).replace(/"/g, "");
    }

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    setTimeout(function() {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 1000);
  }

  static openInNewTab(dataUrlBlob) {
    // Convert the blob containing data URL string to text
    const reader = new FileReader();
    reader.onload = function(e) {
      const dataUrlString = e.target.result;

      // Extract the base64 part after the comma
      const base64Data = dataUrlString.split(",")[1];

      // Decode base64 to actual binary data
      const binaryString = atob(base64Data);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Extract content type from data URL (e.g., "application/pdf")
      const contentType = dataUrlString.split(";")[0].split(":")[1];

      // Create proper blob with binary data and correct content type
      const properBlob = new Blob([bytes], { type: contentType });

      // Open in new tab with the properly decoded blob
      const blobUrl = URL.createObjectURL(properBlob);
      window.open(blobUrl, "_blank");

      // Clean up blob URL after content loads
      setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
    };
    reader.readAsText(dataUrlBlob);
  }
}

export default FileHelper;
